<template>
  <v-card-text v-if="etablissement">
    <etablissement-export-paye-dialog v-model="showExportPayeDialog" :etablissement="etablissement" />
    <v-row>
      <v-col cols="12">
        <v-btn color="info" outlined raised class="mr-2" @click="showExportPayeDialog = true">
          <v-icon small class="mr-2">fa-file-export</v-icon>
          Export Paye
        </v-btn>
        <v-btn
          v-if="isInRole('Administrateur')"
          color="info"
          outlined
          raised
          class="mr-2"
          @click="exporterAnnualisation"
        >
          <v-icon small class="mr-2">fa-file-export</v-icon>
          Export Annualisation
        </v-btn>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EtablissementExportPayeDialog from '../../../components/etablissement/etablissement-export-paye-dialog.vue'
import moment from 'moment'

export default {
  name: 'etablissement-detail-export-paye',
  components: {
    EtablissementExportPayeDialog,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      etablissement: undefined,
      showExportPayeDialog: false,
    }
  },
  computed: {
    ...mapGetters({
      isInRole: 'security/isInRole',
      selectedEtablissement: 'application/getSelectedEtablissement',
    }),
  },
  created() {
    this.etablissement = this.value
  },
  watch: {
    value() {
      this.etablissement = this.value
    },
    etablissement: {
      handler() {
        this.$emit('input', this.etablissement)
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      exporterPDFAnnualisation: 'etablissement/exportAnnualisation',
    }),
    exporterAnnualisation() {
      this.exporterPDFAnnualisation({
        id: this.selectedEtablissement.etablissementId,
        annee: moment().year(),
      })
    },
  },
}
</script>
